<ccp-form-title [formTitle]="formTitle"></ccp-form-title>
<div class="planner-content container-fluid">
    <div class="constraint-group">
        <!--Plan Confirmation Page-->
        <div class="constraint-content">
            <div class="container-fluid plan-confirmation-content">

                <section class="constraint-group">
                    <div class="constraint-header" (click)="showPlanSettings = !showPlanSettings">
                        <acl-ngx-icon contentClass="caret-icon"
                            [name]="showPlanSettings ? 'ChevronDown' : 'ChevronRight'">
                        </acl-ngx-icon>
                        <label class="font-weight-bold">Plan Settings</label>
                    </div>
                    <hr>

                    <div class="container-fluid constraint-content" *ngIf="showPlanSettings">
                        <table class="table table-bordered">
                            <!--Advertiser-->
                            <tr>
                                <td><label class="font-weight-bold">Advertiser Name</label></td>
                                <td>{{ planDetail.advertiserName }}</td>
                            </tr>
                            <!--Name-->
                            <tr>
                                <td><label class="font-weight-bold">Name</label></td>
                                <td>{{ planDetail.name }}</td>
                            </tr>
                            <!--Id-->
                            <tr>
                                <td><label class="font-weight-bold">Id</label></td>
                                <td>{{ planDetail.id }}</td>
                            </tr>
                            <!--Status-->
                            <tr>
                                <td><label class="font-weight-bold">Status</label></td>
                                <td>{{ planDetail.status }}</td>
                            </tr>
                            <!--Label-->
                            <tr>
                                <td>
                                    <label class="font-weight-bold">Labels</label>
                                </td>
                                <td>{{ planDetail.labels }}</td>
                            </tr>
                            <!--Format-->
                            <tr>
                                <td><label class="font-weight-bold">Format</label></td>
                                <td>{{ planDetail.channels }}</td>
                            </tr>
                            <!--Plan Objective-->
                            <!--Not supported for V1 & V2-->
                            <!-- <tr>
                                <td><label class="font-weight-bold">Plan Objective</label></td>
                                <td>{{ planDetail.objective }}</td>
                            </tr> -->
                            <!--Flight Schedule-->
                            <tr>
                                <td><label class="font-weight-bold">Flight Schedule</label></td>
                                <td>{{ planDetail.flightSchedule | json }}</td>
                            </tr>
                        </table>
                    </div>
                </section>

                <section class="constraint-group">
                    <div class="constraint-header"
                        (click)="showDigitalVideoFormatSettings = !showDigitalVideoFormatSettings">
                        <acl-ngx-icon contentClass="caret-icon"
                            [name]="showDigitalVideoFormatSettings ? 'ChevronDown' : 'ChevronRight'">
                        </acl-ngx-icon>
                        <label class="font-weight-bold">Digital Video Format Settings</label>
                    </div>
                    <hr>

                    <div class="container-fluid constraint-content" *ngIf="showDigitalVideoFormatSettings">
                        <table class="table table-bordered">
                            <!--Environments-->
                            <tr>
                                <td><label class="font-weight-bold">Environments</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].environments | json }}</td>
                            </tr>
                            <!--Commenting it as its not supported for V1 as per [CSYS-4705]-->
                            <!--Linear Viewership Audience-->
                            <!-- <tr>
                                <td><label class="font-weight-bold">Linear Viewership Audience</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].useLinearSchedule | json }}</td>
                            </tr> -->
                            <!--Goals-->
                            <tr>
                                <td><label class="font-weight-bold">Goals</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].goals | json }}</td>
                            </tr>
                            <!--Open Auction Exchanges-->
                            <tr>
                                <td><label class="font-weight-bold">Open Auction Exchanges</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].inventorySources | json }}</td>
                            </tr>
                            <!--Private Deals-->
                            <tr>
                                <td><label class="font-weight-bold">Private Deals</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].deals | json }}</td>
                            </tr>
                            <!--Guaranteed Deals-->
                            <tr>
                                <td><label class="font-weight-bold">Guaranteed Deals</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].pgDeals | json }}</td>
                            </tr>
                            <!--Amobee Preferred Deals Store-->
                            <tr>
                                <td><label class="font-weight-bold">Amobee Preferred Deals Store</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].preferredDeals | json }}</td>
                            </tr>
                            <!--Audience Segments-->
                            <tr
                                *ngIf="planDetail.channelPlan.digital.tactics[0].includeSegments.length > 0 || planDetail.channelPlan.digital.tactics[0].excludeSegments.length > 0">
                                <!--Custom Segments/ TVA Segments / TVA Deterministic Segments-->
                                <td><label class="font-weight-bold">Audience Segments:
                                        <b>{{planDetail.channelPlan.digital.tactics[0].segmentTargetingType}}</b></label>
                                </td>
                                <td>
                                    <span *ngIf="planDetail.channelPlan.digital.tactics[0].includeSegments.length > 0">
                                        <label class="font-weight-bold">Include Segments:
                                            {{planDetail.channelPlan.digital.tactics[0].includeOperator}}</label>
                                        <br />
                                        {{ planDetail.channelPlan.digital.tactics[0].includeSegments | json }}
                                        <br />
                                        <br />
                                    </span>
                                    <span *ngIf="planDetail.channelPlan.digital.tactics[0].excludeSegments.length > 0">
                                        <label class="font-weight-bold">Exclude Segments:
                                            {{planDetail.channelPlan.digital.tactics[0].excludeOperator}}</label>
                                        <br />
                                        {{ planDetail.channelPlan.digital.tactics[0].excludeSegments | json }}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="!isObjectEmpty(planDetail.channelPlan.digital.tactics[0].segmentSet)">
                                <td><label class="font-weight-bold">Audience Segments: <b>Segment Set</b></label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].segmentSet | json }}</td>
                            </tr>
                            <!--Geographic-->
                            <tr>
                                <td><label class="font-weight-bold">Geographic</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].regionMap | json }}</td>
                            </tr>
                            <!--Not supported for V1 as per [CSYS-5054]-->
                            <!--Max Creative Length-->
                            <!-- <tr>
                                <td><label class="font-weight-bold">Max Creative Length</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].videoDuration | json }}</td>
                            </tr> -->
                            <!--Creative Type-->
                            <!-- <tr>
                                <td><label class="font-weight-bold">Creative Type</label></td>
                                <td>{{ planDetail.channelPlan.digital.tactics[0].vpaid | json }}</td>
                            </tr> -->
                            <tr>
                                <td><label class="font-weight-bold">Targeting</label></td>
                                <td>
                                    <div class="container">
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">AD VISIBILITY
                                            </div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].adVisibility | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">ADS.TXT</div>
                                            <div class="col-9 padding-5">
                                                {{ planDetail.channelPlan.digital.tactics[0].adsTxtStatuses | json }}
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">AUDIENCE SEGMENTS
                                            </div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">BID PRICE</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">DEVICES</div>
                                            <div class="col-9 padding-5">
                                                {{ planDetail.channelPlan.digital.tactics[0].deviceTypes | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">FREQUENCY</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].frequencyCap | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">PLAYER SIZE</div>
                                            <div class="col-9 padding-5">
                                                {{ planDetail.channelPlan.digital.tactics[0].playerSizes | json }}
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">SITE LIST</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].siteLists | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">APP LIST</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].appLists | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">GEO TARGETING
                                            </div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">BRAND SAFETY
                                            </div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].brandSafety | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">PAGE QUALITY
                                            </div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].pageQuality | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">CONTEXTUAL</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                                {{ planDetail.channelPlan.digital.tactics[0].contextual | json }}
                                            </div>
                                        </div>
                                        <div class="row border-top padding-5">
                                            <div class="col-2 border-right padding-5 font-weight-bold">DAYPARTING</div>
                                            <div class="col-9 padding-5">
                                                <!-- Targeting Component -->
                                            </div>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                        </table>
                    </div>
                </section>
            </div>

            <div class="footer-container">
                <div class="footer text-right padding-10 w-100">
                    <acl-ngx-button contentClass="margin-5" variant="primary" label="Edit Plan"
                        (click)="editPlan(planDetail.id)" id="edit-plan">
                    </acl-ngx-button>
                    <acl-ngx-button contentClass="margin-5" id="back-to-list" variant="neutral" label="Back To List"
                        (click)="backToList()">
                    </acl-ngx-button>
                </div>
            </div>
        </div>
    </div>
</div>
